
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { parsePhoneNumber } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';
import Request from "../../core/httpClient";
const request = new Request();




const PropietarioEditarModal = ({ propietario, telefonoError, setInfo, subLabel, subname }) => {
	const [state, setState] = useState({
		idPersona: 0,
		pNombre: '',
		IDireccion: '',
		IMunicipio: '',
		IEstado: '',
		ICp: '',
		pTelefono: '',
		IPais: '',
		IGenero: 0,
		IId: '',
		INumId: '',
		IVigencia: '',
		IFechaIngreso: '',
		code: '',
		Iviv: '',
		IIdViv: 0,
		email: '',
		pFechaVenta: '',
		citye: '',
		comentarios: '',
		es_residente: '',
		telefonoError: ''
	});

	// Notificar cambios al padre
	useEffect(() => {
		setInfo(state);
	}, [state, setInfo]);

	// Actualizar error de teléfono
	useEffect(() => {
		if (telefonoError) {
			setState(prev => ({ ...prev, telefonoError }));
		}
	}, [telefonoError]);

	// Actualizar datos del propietario
	useEffect(() => {
		if (propietario) {
			let phone = '';
			const { telefono } = propietario;
			if (telefono) {
				const parsed = parsePhoneNumber(`+${telefono}`);
				if (parsed) {
					phone = parsed.number;
				}
			}

			setState(prev => ({
				...prev,
				pIdPersona: propietario.id_persona,
				pNombre: propietario.nombre,
				pDireccion: propietario.direccion,
				pMunicipio: propietario.municipio,
				pEstado: propietario.estado,
				pCp: propietario.cp,
				pTelefono: phone,
				pPais: propietario.pais,
				pGenero: propietario.genero,
				pId: propietario.tipo_identificacion,
				pNumId: propietario.num_identificacion,
				pVigencia: propietario.vigencia_identificacion,
				pFechaCompra: propietario.fecha_compra
					? moment(propietario.fecha_compra).format('YYYY-MM-DD')
					: '',
				pFechaVenta: propietario.fecha_venta
					? moment(propietario.fecha_venta).format('YYYY-MM-DD')
					: '',
				code: propietario.code,
				Iviv: propietario.numero_registro,
				pIdViv: propietario.id_vivienda,
				email: propietario.email,
				citye: propietario.ciudad || '',
				comentarios: propietario.comentarios || '',
				es_residente: propietario.es_residente || ''
			}));
		}
	}, [propietario]);
	return (
		<div className="full row align-center">
			<div className="flex flex-col w-full space-y-4">
				{/* Subfraccionamiento */}
				<div className="flex items-center w-full">
					<label className="w-1/4 font-medium">
						{subLabel}:
					</label>
					<input
						type="text"
						name="subfraccionamiento"
						disabled
						value={subname}
						className="w-3/4 border rounded px-3 py-2 bg-gray-100"
						placeholder="Subfraccionamiento"
					/>
				</div>

				{/* Unidad */}
				<div className="flex items-center w-full">
					<label className="w-1/4 font-medium">Unidad:</label>
					<input
						type="text"
						name="vivienda"
						disabled
						value={state.Iviv}
						onChange={e => setState(prev => ({ ...prev, Iviv: e.target.value }))}
						className="w-3/4 border rounded px-3 py-2 bg-gray-100"
						placeholder="N° de vivienda"
						maxLength="64"
					/>
				</div>

				{/* Teléfono */}
				<div className="flex items-center w-full">
					<label className="w-1/4 font-medium">
						Teléfono:<span className="text-red-500"> *</span>
					</label>
					<PhoneInput
						displayInitialValueAsLocalNumber
						name="phoneNumber"
						defaultCountry="MX"
						maxLength="18"
						placeholder="Número de teléfono"
						value={state.pTelefono}
						disabled
						onChange={value => setState(prev => ({ ...prev, pTelefono: value, telefonoError: undefined }))}
						error={state.telefonoError}
						readOnly
						className="w-3/4 border rounded px-3 py-2 bg-gray-100"
					/>
				</div>

				{/* Nombre */}
				<div className="flex items-center w-full">
					<label className="w-1/4 font-medium">
						Nombre completo:<span className="text-red-500"> *</span>
					</label>
					<input
						type="text"
						name="fullName"
						value={state.pNombre}
						onChange={e => setState(prev => ({ ...prev, pNombre: e.target.value }))}
						className="w-3/4 border rounded px-3 py-2 bg-gray-100"
						placeholder="Nombre completo del propietario"
						maxLength="64"
						disabled
					/>
				</div>

				{/* Género + Email */}
				<div className="flex flex-wrap items-center w-full">
					<label className="w-1/4 font-medium">Género:</label>
					<select
						name="sex"
						value={state.pGenero}
						onChange={e => setState(prev => ({ ...prev, pGenero: e.target.value }))}
						className="w-1/4 border rounded px-3 py-2 input-edit "
					>
						<option value="0">Hombre</option>
						<option value="1">Mujer</option>
						<option value="2">No especificado</option>
					</select>
					<label className="w-1/4 font-medium pl-5">Correo:</label>
					<input
						type="email"
						value={state.email}
						onChange={e => setState(prev => ({ ...prev, email: e.target.value }))}
						className="w-1/4 border rounded px-3 py-2 input-edit"
						placeholder="Email"
						maxLength="64"
					/>
				</div>

				{/* Identificación */}
				<div className="flex flex-wrap items-center w-full">
					<label className="w-1/4 font-medium">Identificación:</label>
					<select
						name="id"
						value={state.pId}
						onChange={e => setState(prev => ({ ...prev, pId: e.target.value }))}
						className="w-1/4 border rounded px-3 py-2 input-edit"
					>
						<option value="0">INE</option>
						<option value="1">Pasaporte/Visa</option>
						<option value="2">Curp</option>
						<option value="3">Cartilla Militar</option>
					</select>
					<label className="w-1/4 font-medium pl-5">ID:</label>
					<input
						type="text"
						name="numIdEddit"
						value={state.pNumId}
						onChange={e => setState(prev => ({ ...prev, pNumId: e.target.value }))}
						className="w-1/4 border rounded px-3 py-2 input-edit"
						placeholder="Número ID"
						maxLength="24"
					/>
				</div>


				<div className="flex flex-col w-full space-y-4">
					{/* Dirección */}
					<div className="flex items-center w-full">
						<label className="w-1/4 font-medium">Dirección:</label>
						<input
							type="text"
							name="address"
							value={state.pDireccion}
							onChange={e => setState(prev => ({ ...prev, pDireccion: e.target.value }))}
							className="w-3/4 border rounded px-3 py-2 input-edit"
							placeholder="Dirección de contacto"
							maxLength="150"
						/>
					</div>

					{/* Municipio + Ciudad */}
					<div className="flex flex-wrap items-center w-full">
						<label className="w-1/4 font-medium">Municipio:</label>
						<input
							type="text"
							name="municipality"
							value={state.pMunicipio}
							onChange={e => setState(prev => ({ ...prev, pMunicipio: e.target.value }))}
							className="w-1/4 border rounded px-3 py-2"
							placeholder="Municipio"
							maxLength="80"
						/>
						<label className="w-1/4 font-medium pl-5">Ciudad:</label>
						<input
							type="text"
							value={state.citye}
							onChange={e => setState(prev => ({ ...prev, citye: e.target.value }))}
							className="w-1/4 border rounded px-3 py-2 input-edit"
							id="citye"
							placeholder="Ciudad"
						/>
					</div>

					{/* C.P + Estado */}
					<div className="flex flex-wrap items-center w-full">
						<label className="w-1/4 font-medium">C.P:</label>
						<input
							type="text"
							value={state.pCp}
							onChange={e => setState(prev => ({ ...prev, pCp: e.target.value }))}
							name="zip"
							className="w-1/4 border rounded px-3 py-2 input-edit"
							placeholder="Código postal"
							maxLength="10"
						/>
						<label className="w-1/4 font-medium pl-5">Estado:</label>
						<input
							type="text"
							name="state"
							value={state.pEstado}
							onChange={e => setState(prev => ({ ...prev, pEstado: e.target.value }))}
							className="w-1/4 border rounded px-3 py-2 input-edit"
							placeholder="Estado"
							maxLength="24"
						/>
					</div>

					{/* País */}
					<div className="flex items-center w-full">
						<label className="w-1/4 font-medium">País:</label>
						<input
							type="text"
							value={state.pPais}
							onChange={e => setState(prev => ({ ...prev, pPais: e.target.value }))}
							name="country"
							className="w-3/4 border rounded px-3 py-2 input-edit"
							placeholder="País"
							maxLength="10"
						/>
					</div>

					{/* Fechas */}
					<div className="flex flex-wrap items-center w-full">
						<label className="w-1/4 font-medium">
							Fecha de compra:<span className="text-red-500"> *</span>
						</label>
						<input
							type="date"
							value={state.pFechaCompra}
							onChange={e => setState(prev => ({ ...prev, pFechaCompra: e.target.value }))}
							required
							className="w-1/4 border rounded px-3 py-2 input-edit"
							id="fcompra"
						/>
						<label className="w-1/4 font-medium pl-5">Fecha de venta:</label>
						<input
							type="date"
							value={state.pFechaVenta}
							onChange={e => setState(prev => ({ ...prev, pFechaVenta: e.target.value }))}
							className="w-1/4 border rounded px-3 py-2 input-edit"
							id="fventaedit"
						/>
					</div>

					{/* Comentarios + Residente */}
					<div className="flex flex-wrap items-center w-full">
						<label className="w-1/4 font-medium">Comentarios:</label>
						<textarea
							name="comentarios"
							id="comentarios_inquilinos"
							value={state.comentarios}
							onChange={e => setState(prev => ({ ...prev, comentarios: e.target.value }))}
							className="w-3/4 border rounded px-3 py-2 input-edit"
							rows="3"
							maxLength="500"
						/>
						{/* Estado residente */}
						<div className="flex flex-col md:flex-row flex-wrap w-full mb-3">
							<div className="flex-1 px-2 py-1">
								{state.es_residente ? (
									<span className="text-green-600 font-bold flex items-center gap-2">
										<b>Es residente</b>
										<i className="fas fa-check"></i>
									</span>
								) : (
									<span className="text-red-600 font-bold flex items-center gap-2">
										<b>No es residente</b>
										<i className="fas fa-times"></i>
									</span>
								)}
							</div>
						</div>

					</div>

					{/* Nota */}
					<div className="flex items-center w-full">
						<p>
							<span className="text-red-500">*</span>
							<small className="ml-1">Indica un campo obligatorio</small>
						</p>
					</div>
				</div>




			</div>
		</div >
	);
};

export default PropietarioEditarModal;
